/*!
 * SAPUI5
 * Copyright (c) 2025 SAP SE or an SAP affiliate company. All rights reserved.
 */
export enum PersonalizationKeys {
    nlqActive = "nlq-active",
    searchFacetPanelButtonState = "search-facet-panel-button-state",
    searchBasketPanelButtonState = "search-basket-panel-button-state",
    resultViewTypeForAllAndCategorySearch = "resultViewTypeForAllAndCategorySearch",
    resultViewTypeForBusinessObjectSearch = "resultViewTypeForBusinessObjectSearch",
    searchFacetPanelChartState = "search-facet-panel-chart-state",
    recentSearches = "ESH-Recent-Searches",
    searchResultTableState = "search-result-table-state-",
    myFavorites = "my-fav-data",
}
